import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatLogOperation',
    standalone: false
})
export class FormatLogOperationPipe implements PipeTransform {
    transform(value: any): string {
        if (typeof value !== 'object' || value === null || !value.entityType) {
            return 'Operação não informada';
        }

        const entityType = value.entityType as string;

        if (entityType.includes('.animals.Animal')) {
            return 'Criação de Animal';
        }
        if (entityType.includes('.matings.')) {
            return 'Cobertura';
        }
        if (entityType.includes('.pregnancies.')) {
            return 'Prenhez';
        }
        if (entityType.includes('.childBirths.Conventional')) {
            return 'Parto';
        }
        if (entityType.includes('.childBirths.Abortion')) {
            return 'Aborto';
        }
        if (entityType.includes('.dries.')) {
            return 'Secagem';
        }
        if (entityType.includes('.herdOuts.')) {
            return 'Saída de Rebanho';
        }

        return 'Operação Desconhecida';
    }
}
